import { render } from "./cartCard.vue?vue&type=template&id=5b62364c"
import script from "./cartCard.vue?vue&type=script&lang=js"
export * from "./cartCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__